angular.
module("dx.webapp.jobs").
constant("DX_JOB_STATUS", Object.freeze({
	CREATED: "created",
	RUNNING: "running",
	DONE: "done",
}));
